// extracted by mini-css-extract-plugin
export var documentation = "_ht-1";
export var menu = "_ht-0";